export const getters = {
    receiptsInfo: state => state.receiptsInfo,
    receiptsContent: state => state.receiptsInfo && state.receiptsInfo.content,
    isNewPaymentFlowFeatureEnabled: state => state.isNewPaymentFlowFeature && state.isNewPaymentFlowFeature.enabled,
    isPaynowPrevPageDisabled: state => state.paynowReceiptsPaginationParams.isPrevDisabled,
    isPaynowNextPageDisabled: state => state.paynowReceiptsPaginationParams.isNextDisabled,
    paynowTransactionPageSize: state => state.paynowTransactionPageSize,
};



// WEBPACK FOOTER //
// ./src/store/modules/receipts/getters.js